import type { Editor, JSONContent } from '@tiptap/react';
import { formatTemplateToken, splitTemplate } from '@cotera/utilities';
import { VARIABLE_PILL_NAME } from './variable-pill.node';

/** Builds a ProseMirror doc from a `{{ref}}`-templated string (newline = paragraph). */
export function templateToDoc(template: string): JSONContent {
  const lines = template.split('\n');
  return {
    type: 'doc',
    content: lines.map((line) => ({
      type: 'paragraph',
      content: splitTemplate(line).flatMap((segment): JSONContent[] => {
        if (segment.t === 'text') {
          return segment.value === ''
            ? []
            : [{ type: 'text', text: segment.value }];
        }
        return [{ type: VARIABLE_PILL_NAME, attrs: { ref: segment.ref } }];
      }),
    })),
  };
}

/** Serializes the editor doc back to a `{{ref}}`-templated string. */
export function editorToTemplate(editor: Editor): string {
  const lines: string[] = [];
  editor.state.doc.forEach((block) => {
    let line = '';
    block.forEach((inline) => {
      if (inline.type.name === VARIABLE_PILL_NAME) {
        line += formatTemplateToken(String(inline.attrs['ref'] ?? ''));
      } else if (inline.isText) {
        line += inline.text ?? '';
      }
    });
    lines.push(line);
  });
  return lines.join('\n');
}
